import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MdLocationOn, MdEmail } from "react-icons/md";
import { PiBuildingApartmentFill, PiGlobe } from "react-icons/pi";
import { BiSolidPhoneCall } from "react-icons/bi";

import * as apiUrl from "../../apiUrl";

function ContactLocation() {
  const [ContactLocation, setContactLocation] = useState({});

  useEffect(() => {
    const fetchContactLocation = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/contact/location-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setContactLocation(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchContactLocation();
  }, []); 
  const phones = ContactLocation.phone
    ? Object.values(JSON.parse(ContactLocation.phone))
    : [];


  return ( 
      <section className="contact-location-sec">
        <Container fluid>
          <Row className="flex-center">
            <Col md={12}>
              <div className="construction-location-sec">
                <Row>
                  <Col md={12}>
                    <div className="heading-div" data-aos="fade-up">
                      <h2 className="common-head darkGrey">
                        {ContactLocation.section_title}{" "}
                        <MdLocationOn className="goldenColor" />
                      </h2>

                      <p className="common-para">
                        <PiBuildingApartmentFill className="goldenColor" />{" "}
                        Office: {ContactLocation.address}
                      </p>

                      {phones.length > 0 && (
                        <p className="common-para">
                          <BiSolidPhoneCall className="goldenColor" /> Phone:{" "}
                          {phones.map((phone, index) => (
                            <a
                              key={index}
                              href={`tel:${phone}`}
                              className="phone-link"
                              style={{
                                marginRight:
                                  index !== phones.length - 1 ? "10px" : "0",
                              }} 
                            >
                              {phone}
                            </a>
                          ))}
                        </p>
                      )}

                      <p className="common-para">
                      <MdEmail className="goldenColor" />{" "}
                          Email:  {" "}
                         <a
                          href={`mailto:${ContactLocation.email}`}
                          className="contact-email-link"
                        >
                           {ContactLocation.email}
                        </a>
                      </p>

                      <p className="common-para">
                        <PiGlobe className="goldenColor" />{" "}
                        Website:  
                        <a
                          href={"https://marquisdevelopers.com/"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {ContactLocation.website}
                        </a>
                      </p>
                    </div>

                    {ContactLocation.map_location && (
                      <iframe
                        src={ContactLocation.map_location}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        data-aos="fade-up"
                        className="map-iframe"
                      ></iframe>
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section> 
  );
}

export default ContactLocation;
